import {combineReducers} from 'redux';
import VenueList from './venueList';
import Location from './location';
import Loader from './loader';
import DetailPage from './detailPage';
import SportsFilter from './sportsFilter';
import Shimmer from './shimmerEffect';
import ViewPort from './viewPort';
import Offers from './offerList';
import OfferDetails from './offerDetailPage';
import HamMenu from './hamburgerMenu';
import EventsList from './eventsList';
import EventDetail from './eventDetailPage';
import Popular from './popularSection';
import CitySelected from './citySelected';

const rootReducers = combineReducers({
   VenueList , Location , Loader, DetailPage , SportsFilter ,
   Shimmer , ViewPort, Offers , OfferDetails , HamMenu , EventsList , EventDetail, Popular , CitySelected
});

export default rootReducers;



// WEBPACK FOOTER //
// ./src/reducers/rootReducers.js